<template>
  <div
    :class="{
      'bg-default-login': isPagesBg,
      'is-login': isPageLogin,
      'is-config-layout': isConfigLayout,
    }"
  >
    <loading :active="isLoading" :is-full-page="true"></loading>
    <!-- DEFINE HEADER -->
    <Header :array-pages-has-bg="arrayPagesHasBg" />
    <!-------------------->
    <main>
      <RouterView />
    </main>
    <BtnHelp v-if="arrayPagesNotBtnHelp.indexOf($route.name) === -1" />
    <ModalHelp />
  </div>
</template>

<script>
import Header from "@/components/header/index";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";
import BtnHelp from "@/components/btns/BtnHelp.vue";
import ModalHelp from "@/components/modals/ModalHelp.vue";

export default {
  components: {
    Header,
    Loading,
    BtnHelp,
    ModalHelp,
  },
  computed: {
    ...mapGetters(["isLoading"]),
    isPagesBg() {
      return this.arrayPagesHasBg.indexOf(this.$route.name) > -1;
    },
    isPageLogin() {
      return this.$route.name === "login";
    },
    isConfigLayout() {
      return this.$route.name === "config-layout";
    },
  },
  data() {
    return {
      arrayPagesHasBg: ["login", "home", "build-pack"],
      arrayPagesNotBtnHelp: ["login", "callback"],
    };
  },
};
</script>

<style lang="scss">
@import "./assets/scss/generic/mixins.scss";
@import "./assets/scss/generic/fonts.scss";
@import "./assets/scss/generic/utilities.scss";

.bg-default-login {
  width: 100%;
  min-height: 100vh;
  background: url("~@/assets/img/bg-login.png");
  background-repeat: no-repeat;
  background-position-x: -4px;
  background-position-y: -4px;
  background-size: cover;
  @media (max-width: 991px) {
    background-size: initial;
  }
  main {
    @media (min-width: 992px) {
      padding-top: 0;
    }
  }
}
.is-login {
  main {
    padding-top: 126px;
    @media (max-width: 767px) {
      padding-top: 0;
    }
  }
}
.is-config-layout {
  background: var(--color-gray-light);
  @media (max-width: 991px) {
    background: var(--color-white);
  }
  .header {
    background: transparent;
    @media (max-width: 991px) {
      background: var(--color-white);
    }
  }
  main {
    max-width: 100%;
    padding-top: 0;
  }
}
</style>
